module.exports = __webpack_public_path__ + "static/media/hockey-league.f39a97c2.gif";